import React from 'react';
import './styles.scss';

const CountdownTimer = ({ timeLeft }) => {
  const millisecondsPerSecond = 1000;
  const millisecondsPerMinute = 60 * millisecondsPerSecond;
  const millisecondsPerHour = 60 * millisecondsPerMinute;
  const millisecondsPerDay = 24 * millisecondsPerHour;

  const days = Math.floor(timeLeft / millisecondsPerDay);
  const hours = Math.floor((timeLeft % millisecondsPerDay) / millisecondsPerHour);
  const minutes = Math.floor((timeLeft % millisecondsPerHour) / millisecondsPerMinute);
  const seconds = Math.floor((timeLeft % millisecondsPerMinute) / millisecondsPerSecond);

  return (
    <div className="courses-countdown-timer">
      <div className="courses-countdown-timer__box">{String(days).padStart(2, '0')} Days</div>
      <div className="courses-countdown-timer__box">{String(hours).padStart(2, '0')} Hrs</div>
      <div className="courses-countdown-timer__box">{String(minutes).padStart(2, '0')} Min</div>
      <div className="courses-countdown-timer__box">{String(seconds).padStart(2, '0')} Sec</div>
    </div>
  );
};

export default CountdownTimer;
